export default __webpack_public_path__ + "static/media/09d.231cb83b.png";